import React, { Component } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import API from '../../utils/api';

import {
  getCurrentTeacher,
  getCurrentOrg,
  api2ClassesByOrganizationId
} from "../../utils/operations.js";

import { observer, inject } from "mobx-react";
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify';
import moment from "moment";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

class NewTeacher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        photo: "",
        photofile: "",
        firstname: "",
        lastname: "",
        birthday: new Date(),
        organisation: "",
        classes: "",
        email: "",
        phone: "",
        address: "",
      },
      organisations: [],
      classes: [],
      currentOrgClasses: [],
      opendialog: false,
      texterrors: "",
      showProgress: false
    };
  }

  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    let orgId = this.props.Auth.orgId;

    let that = this;
    axios
      .all([
        API.get(getCurrentOrg + orgId),
        API.get(api2ClassesByOrganizationId(orgId))
      ])
      .then(
        axios.spread(function(organisations, classes) {
          let gotClasses = classes.data.data;
          let gotOrg = organisations.data;
          let relationClasses = [];

          for (let j = 0; j < gotClasses.length; j++) {
            if (gotOrg.id === gotClasses[j].organisation_id) {
              relationClasses.push(gotClasses[j]);
            }
          }
          gotOrg.classes = relationClasses;

          let data = {};
          data.organisation = Number(orgId);

          that.setState({ organisations: [gotOrg] });
          that.setState({ classes: gotClasses });
          that.setState({ data });
          that.setState({ showProgress: false });
        })
      );
  };

  saveData = async () => {
    try {
      const data = {
        resource: [
          {
            firstname: this.state.data.firstname,
            lastname: this.state.data.lastname,
            organisation_id: this.state.data.organisation,
            classes_id: this.state.data.classes,
            email: this.state.data.email,
            phone: this.state.data.phone,
            address: this.state.data.address,
            birthday: moment(this.state.data.birthday).format("YYYY-MM-DD"),
          }
        ]
      };
      await API.post(getCurrentTeacher, data)

      toast.success('New teacher was added successfully!')
      setTimeout(this.props.history.push("/teachers"), 1000);
    } catch (error) {
      let issues = [error.response.data.error.message];
      let texterrors = "";

      for (const key in issues) {
        texterrors += key + ": " + issues[key] + "\n";
      }
      this.setState({ texterrors: texterrors });

      this.handleOpen();
    }
  };

  handleOpen = () => {
    this.setState({ opendialog: true });
  };

  handleClose = () => {
    this.setState({ opendialog: false });
  };

  handleOrgChange = (event, index, value) => {
    const data = this.state.data;
    data.organisation = value;
    data.classes = "";
    this.setState({ data });

    const currentOrgClasses = this.state.organisations[index].classes;
    this.setState({ currentOrgClasses });
  };

  handleClassChange = (event, index, value) => {
    const data = this.state.data;
    data.classes = value;
    this.setState({ data });
  };

  handleChange = event => {
    const data = this.state.data;
    data[event.target.id] = event.target.value;
    this.setState({ data });
  };

  handleBirthday = (birthday) => {
    const data = this.state.data;
    data.birthday = birthday;
    this.setState({ data });
  };

  goPreviousPage = () => {
    this.props.history.goBack();
  };

  render() {
    return (
      <div style={{ maxWidth: 500, margin: "auto" }}>
        <br />
        <TextField
          id="firstname"
          label="First Name"
          error={!this.state.data.firstname}
          helperText={!this.state.data.firstname ? "This field is required" : ""}
          fullWidth={true}
          value={this.state.data.firstname}
          onChange={this.handleChange}
          variant="standard"
        />
        <br />
        <TextField
          id="lastname"
          label="Last Name"
          error={!this.state.data.lastname}
          helperText={!this.state.data.lastname ? "This field is required" : ""}
          fullWidth={true}
          value={this.state.data.lastname}
          onChange={this.handleChange}
          variant="standard"
        />
        <br />
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Birthday"
            value={this.state.data.birthday}
            onChange={this.handleBirthday}
            renderInput={(params) => <TextField {...params} fullWidth variant="standard" />}
            slotProps={{ textField: { fullWidth: true, variant: "standard" } }}
          />
        </LocalizationProvider>
        <br />
        <FormControl fullWidth variant="standard">
          <InputLabel id="organisation-label">School</InputLabel>
          <Select
            labelId="organisation-label"
            id="organisation"
            error={!this.state.data.organisation}
            value={this.state.data.organisation}
            onChange={(e) => this.handleOrgChange(e, 0, e.target.value)}
          >
            {this.state.organisations.map(row => (
              <MenuItem key={row.id} value={row.id}>{row.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <br />
        <FormControl fullWidth variant="standard">
          <InputLabel id="classes-label">Class</InputLabel>
          <Select
            labelId="classes-label"
            id="classes"
            error={!this.state.data.classes}
            value={this.state.data.classes}
            onChange={(e) => this.handleClassChange(e, 0, e.target.value)}
          >
            {this.state.classes.map(rows => (
              <MenuItem key={rows.id} value={rows.id}>{rows.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <br />
        <TextField
          id="email"
          label="Email"
          fullWidth={true}
          value={this.state.data.email}
          onChange={this.handleChange}
          variant="standard"
        />
        <br />
        <InputMask
          mask="999-999-9999 ext. 999"
          fullWidth={true}
          value={this.state.data.phone}
          onChange={this.handleChange}
          id="phone"
          disabled={false}
        >
          {(inputProps) => <TextField {...inputProps} label="Phone" variant="standard" />}
        </InputMask>
        <br />
        <TextField
          id="address"
          label="Address"
          fullWidth={true}
          value={this.state.data.address}
          onChange={this.handleChange}
          variant="standard"
        />
        <br />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '20px',
            paddingTop: 20,
            paddingBottom: 20
          }}
        >
          <Button
            variant="contained"
            color="primary"
            style={{ marginRight: 10 }}
            onClick={this.saveData}
          >
            Save
          </Button>
          <Button
            variant="contained"
            color="secondary"
            style={{ marginLeft: 10 }}
            onClick={this.goPreviousPage}
          >
            Cancel
          </Button>
        </div>
        <Dialog
          open={this.state.opendialog}
          onClose={this.handleClose}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Form errors:</DialogTitle>
          <DialogContent>
            <div>
              {this.state.texterrors.split("\n").map((i, index) => {
                return <div key={index}>{i}</div>;
              })}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default inject("Auth")(observer(NewTeacher))
